/*@ngInject*/
const AddFormRowRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.addFormRow = function (formId, uiRowId, rowNumberOfLastRow) {
        let url = '/rest/FormRow',
            config = {
                params: {
                    formId: formId,
                    uiRowId: uiRowId,
                    rowNumber: rowNumberOfLastRow
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('umFormViewer')
    .service('addFormRowRepository', AddFormRowRepository);
